import { Navigate, useLocation } from 'react-router-dom';

import { IS_V2_WRITE_ENABLED } from '@/configs/v2Write';
import { trackerUrls } from '@/tracker/config/urls';

import { CreateIssueForm } from './ui/CreateIssueForm';

/**
 * Форма заново монтируется при смене ?queue= и ?parent=: «Создать задачу» в навигации ведёт на тот же
 * маршрут, а useForm берёт defaultValues только при монтировании
 */
const CreateIssuePage = () => {
  const { search } = useLocation();

  // Трекер пока бэкап Яндекс Трекера: прямая ссылка на создание ведёт к задачам
  if (!IS_V2_WRITE_ENABLED) return <Navigate to={trackerUrls.root} replace />;

  return <CreateIssueForm key={search} />;
};

export { CreateIssuePage };
